export default __webpack_public_path__ + "static/media/icon_service.e3089d3c.png";